<template>
  <div :class="componentClassName">
    <div class="m-data-card__header">
      <div class="m-data-card__header-title">
        <a-icon v-if="icon" :icon="icon" color="orange" />
        <a-heading :id="id" :heading="title" tag="h4" size="small" />
        <div v-if="help" class="m-data-card__header-title-help">
          <a-button :inline="true" @click="handleHelpClick">
            <a-icon icon="help-outline" color="black" />
          </a-button>
        </div>
      </div>
      <div class="m-data-card__header-datas">
        <slot name="data"></slot>
      </div>
    </div>
    <div class="m-data-card__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AIcon from '@/components/atoms/icon';
import AHeading from '@/components/atoms/heading';
import AButton from '@/components/atoms/button';

export default {
  name: 'm-data-card',
  components: {
    AIcon,
    AHeading,
    AButton,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: undefined,
    },
    help: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    headerBorder: {
      type: Boolean,
      default: false,
    },
    noHeaderMargin: {
      type: Boolean,
      default: false,
    },
    narrowBody: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'headingTitle',
    },
  },
  emits: ['help:click'],
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers(
        'm-data-card',
        this.border ? 'bordered' : '',
        this.headerBorder ? 'header-bordered' : '',
        this.noHeaderMargin ? 'no-header-margin' : '',
        this.narrowBody ? 'narrow-body' : ''
      );
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleHelpClick(e) {
      this.$emit('help:click', e);
    },
  },
};
</script>
